'use es6';

import { hubletApi } from 'hub-http/middlewares/core';
import csrfVerifyClient from '../lib/csrfVerifyClient';
import Cookies from 'js-cookie';
import { OUTLOOK365 } from '../constants/LoginSources';
import * as LoginUtils from '../lib/LoginUtils';
const REMEMBER_DEFAULT = Cookies.get('prefs') === '1';

class BypassLoginDao {
  bypass(credentials) {
    const source = LoginUtils.getLoginSource();

    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }

    credentials.rememberLogin = credentials.rememberLogin !== undefined ? credentials.rememberLogin : REMEMBER_DEFAULT;
    return csrfVerifyClient.post('/login-api/v1/bypass/hubless', {
      data: credentials,
      csrfCookieName: 'csrf.app',
      api: hubletApi('api', 'hubspot')
    });
  }

}

export default BypassLoginDao;